import PublicLayout from "@/components/PublicLayout";
import { EmergencyBox } from "@/components/RequestForm";

const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-xl sm:text-2xl font-bold">{title}</h2>
    <div className="text-[16px] leading-relaxed text-[#241D17] space-y-2">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <PublicLayout>
      <article data-testid="privacy-notice" className="max-w-3xl mx-auto px-5 py-10 sm:py-14 space-y-8">
        <div>
          <h1 className="text-3xl sm:text-4xl font-black">Privacy & Safety Notice</h1>
          <p className="mt-3 text-[#605349]">Saint Francis of Assisi Parish processes personal information in MABUHAY CARE in line with the Data Privacy Act of 2012 (Republic Act No. 10173), its implementing rules, and guidance of the National Privacy Commission. <i>This notice is a working draft for review and approval by the parish and its Data Protection Officer before publication.</i></p>
        </div>
        <Section title="Why we collect your information">
          <p>Only to receive, review, respond to and follow up your request for pastoral care or assistance. We collect only what is needed to understand your request and to contact you.</p>
        </Section>
        <Section title="Who can see it">
          <p>Only authorized parish personnel assigned to your request. GKK officers and general ministry members do not automatically have access. Sensitive matters such as abuse, child protection or serious safety concerns follow a separate confidential pathway seen only by specifically designated, trained personnel.</p>
          <p>Information is shared with a referral partner only with your permission and only the minimum necessary.</p>
        </Section>
        <Section title="What we will never do">
          <ul className="list-disc pl-5 space-y-1">
            <li>Sell, advertise with, or commercially profile your information.</li>
            <li>Use your information to train artificial intelligence, or send case details to unapproved AI services.</li>
            <li>Treat anything written here as sacramental confession. Please do not write confessions here.</li>
            <li>Put your personal circumstances in ordinary text or email notifications.</li>
          </ul>
        </Section>
        <Section title="Your rights">
          <p>You may ask to access or correct your information, object to processing, withdraw optional permissions, or ask the parish to stop contacting you. Please visit the parish office; staff will verify your identity first. Records are kept according to the parish's approved retention schedule and then securely deleted.</p>
        </Section>
        <Section title="Not an emergency service">
          <p>MABUHAY CARE is reviewed during parish office hours. It is not monitored 24 hours a day.</p>
        </Section>
        <EmergencyBox />
      </article>
    </PublicLayout>
  );
}
